<div
  (click)="visible = !visible"
  class="pl-3 pr-2 h-8 border rounded-full flex items-center gap-1 cursor-pointer hover:border-blue-600">
  <span class="font-semibold">{{ label }}: </span>
  <div class="flex gap-0.5 items-center">
    <div class="max-w-[200px] truncate">
      {{ selectedPoliciesString ? selectedPoliciesString : ('common.all' | translate) }}
    </div>
    <i class="icon-wl-arrow-drop-down text-6"></i>
  </div>
</div>

<p-overlay [appendTo]="appendTo" #overlay [(visible)]="visible" contentStyleClass="rounded-md shadow bg-white w-full">
  <div class="h-11 flex items-center gap-2 border-b">
    <app-search-input
      inputClass="border-none !shadow-none"
      [debounceTime]="300"
      (onSearch)="onSearch($event)"></app-search-input>
  </div>
  <div
    class="w-full max-h-[200px] overflow-y-auto"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="onScroll()">
    @if (policies.length) {
      @for (policy of policiesDrop; track policy.id) {
        <div class="flex px-3 hover:bg-neutral-200 py-2 gap-2">
          <p-checkbox [(ngModel)]="policiesSelected" (ngModelChange)="onPoliciesSelectedChange()" [value]="policy"></p-checkbox>
          <div class="cursor-pointer w-full truncate">
            {{ policy?.number ?? '' }}
          </div>
        </div>
      }
    } @else {
      <div class="flex items-center justify-center flex-col gap-2 py-4">
        <div class="h-9 w-9 flex items-center justify-center bg-neutral-alpha-200A rounded-full">
          <i class="icon-wl-user text-6"></i>
        </div>

        <div>No policy to display</div>
      </div>
    }
  </div>
</p-overlay>
